var map = {
	"./dark/status/20weight/03height.svg": "Zp1w",
	"./light/status/20weight/03height.svg": "++E3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Ubb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/20weight\/03height\.svg$
// module id = 4Ubb
// module chunks = 0